var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-SMS_Active"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SMS_Active",
    clipPath: "url(#clip-SMS_Active)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SMS",
    transform: "translate(1 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4772",
    "data-name": "Path 4772",
    d: "M33.516,8.96H10.11A2.6,2.6,0,0,0,7.5,11.569v14.5a2.6,2.6,0,0,0,2.61,2.609H22.234l6.82,3.99v-3.99h4.479a2.6,2.6,0,0,0,2.61-2.609v-14.5a2.6,2.6,0,0,0-2.61-2.609Z",
    transform: "translate(-6.83 -8.273)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4773",
    "data-name": "Path 4773",
    d: "M7.85,9.922l11.034,9.452,2.674,1.564,1.648-.7,2.17-1.358L35,10.146l-.538-.876L32.878,8.96,8.859,9.166Z",
    transform: "translate(-6.578 -8.273)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4774",
    "data-name": "Path 4774",
    d: "M29.34,33.639a.608.608,0,0,1-.337-.1l-6.657-3.893H10.4A3.291,3.291,0,0,1,7.11,26.358V11.847A3.291,3.291,0,0,1,10.4,8.56h8.494a.674.674,0,1,1,0,1.348H10.4a1.938,1.938,0,0,0-1.938,1.938V26.358A1.938,1.938,0,0,0,10.4,28.3H22.531a.608.608,0,0,1,.337.1l5.8,3.388V28.97a.676.676,0,0,1,.674-.674h4.483a1.938,1.938,0,0,0,1.938-1.938V11.847a1.938,1.938,0,0,0-1.938-1.938H24.436a.674.674,0,0,1,0-1.348h9.388a3.291,3.291,0,0,1,3.287,3.287V26.358a3.291,3.291,0,0,1-3.287,3.287H30.031v3.32a.7.7,0,0,1-.337.59.592.592,0,0,1-.337.084Z",
    transform: "translate(-7.11 -8.56)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4775",
    "data-name": "Path 4775",
    d: "M21.834,21.52A2.952,2.952,0,0,1,19.9,20.8L7.688,10.332a.713.713,0,0,1-.084-.98.679.679,0,0,1,.96-.086L20.773,19.732a1.631,1.631,0,0,0,2.139,0L35.138,9.267a.68.68,0,0,1,.96.086.714.714,0,0,1-.084.98L23.787,20.8a2.952,2.952,0,0,1-1.937.722Z",
    transform: "translate(-6.868 -8.167)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2180",
    "data-name": "Group 2180",
    transform: "translate(1.558 10.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4776",
    "data-name": "Path 4776",
    d: "M8.077,24.214a.625.625,0,0,1-.475-.206.632.632,0,0,1,.048-.9l9.567-8.744a.639.639,0,0,1,.855.95L8.5,24.056a.641.641,0,0,1-.428.174Z",
    transform: "translate(-7.435 -14.184)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4777",
    "data-name": "Path 4777",
    d: "M27.922,24.218a.574.574,0,0,1-.428-.174L17.927,15.3a.639.639,0,0,1,.855-.95l9.567,8.744a.647.647,0,0,1,.048.9.625.625,0,0,1-.475.206Z",
    transform: "translate(-1.973 -14.188)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4778",
    "data-name": "Path 4778",
    d: "M16.654,9.945h-.876a.687.687,0,1,1,0-1.375h.876a.687.687,0,1,1,0,1.375Z",
    transform: "translate(-1.662 -8.553)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsActive);
export default __webpack_public_path__ + "static/media/SMS_Active.1612a7cee68314debb510429379f3ab5.svg";
export { ForwardRef as ReactComponent };